// Modern Website Footer



import {
  Box,
  Typography,
  Link,
  Stack,
  IconButton,
  Container,
} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 10,
        py: 5,
        backgroundColor: '#061126',
        color: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={4}
          justifyContent="space-between"
          alignItems={{ xs: 'center', md: 'flex-start' }}
          flexWrap="wrap"
        >
          {/* Brand Info */}
          <Box
            sx={{
              mb: 4,
              flex: '1 1 0',
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Stack spacing={1} alignItems="center">
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Priya Beads
              </Typography>
              <Typography variant="body2">
                © {new Date().getFullYear()} Priya Beads. All rights reserved.
              </Typography>
            </Stack>
          </Box>

          {/* Follow Us */}
          <Box
            sx={{
              mb: 4,
              flex: '1 1 0',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Follow Us
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              flexWrap="wrap"
              justifyContent="center"
            >
              <IconButton
                component="a"
                href="https://www.instagram.com/priya_beads?igsh=MTg0emhxdm01NHl5Ng=="
                target="_blank"
                rel="noopener"
                sx={{
                  color: 'white',
                  '&:hover': { color: '#E1306C' },
                }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.facebook.com/share/16SbVCU1Vf/"
                target="_blank"
                rel="noopener"
                sx={{
                  color: 'white',
                  '&:hover': { color: '#1877F2' },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://wa.me/917233034085"
                target="_blank"
                rel="noopener"
                sx={{
                  color: 'white',
                  '&:hover': { color: '#25D366' },
                }}
              >
                <WhatsAppIcon />
              </IconButton>
            </Stack>
          </Box>

          {/* Contact Info */}
          <Box
            sx={{
              mb: 4,
              flex: '1 1 0',
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Stack spacing={1} alignItems="center">
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Contact Us
              </Typography>
              <Typography variant="body2">📞 +91 72330 34085</Typography>
              <Typography variant="body2">✉️ contact@priyabeads.com</Typography>
              <Typography variant="body2">
                📍 C 15/392 Lallapura, Matakund,
              </Typography>
              <Typography variant="body2">
                Varanasi, Uttar Pradesh
              </Typography>
            </Stack>
          </Box>

          {/* Privacy Policy */}
          <Box
            sx={{
              mb: 4,
              flex: '1 1 0',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Privacy & Return Policy
            </Typography>
            <Stack spacing={1} alignItems="center">
              <Stack spacing={1} alignItems="center">
                <Typography variant="body2">
                  <Link
                    href="/aboutus"
                    underline="hover"
                    color="inherit"
                  >
                    About Us
                  </Link>
                </Typography>
              </Stack>
              <Typography variant="body2">
                <Link
                  href="/privacy-policy"
                  underline="hover"
                  color="inherit"
                >
                  View Privacy & Return Policy
                </Link>
              </Typography>
            </Stack>
            <Stack spacing={1} alignItems="center">
              <Typography variant="body2">
                <Link
                  href="/term-and-condition"
                  underline="hover"
                  color="inherit"
                >
                  View Term & Condition
                </Link>
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;